/**
 * Módulo de Segurança
 * ⚠️ Bloqueio de console/DevTools/F12 foi DESATIVADO a pedido do usuário (2026-07-28),
 * para permitir diagnosticar problemas de carregamento de dados em produção.
 * O bloqueio dificultava a própria equipe/admin de depurar erros reais do sistema.
 * Mantém apenas a limpeza de storage de debug (não afeta o DevTools).
 */

export const initializeSecurity = () => {
  // 5️⃣ LIMPAR STORAGE DE DEBUG (preservando dados do Supabase Auth)
  try {
    // Preservar chaves do Supabase Auth (tokens de sessão)
    const keysToKeep: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('sb-') || key.startsWith('supabase'))) {
        keysToKeep.push(key);
      }
    }
    const preserved: Record<string, string> = {};
    keysToKeep.forEach(key => {
      const val = localStorage.getItem(key);
      if (val) preserved[key] = val;
    });

    // Limpar e restaurar dados do Supabase
    localStorage.clear();
    Object.entries(preserved).forEach(([key, val]) => localStorage.setItem(key, val));
    sessionStorage.clear();
  } catch (e) {
    // Ignorar erros de storage
  }
};

/**
 * Integração com React: chamar no useEffect
 * 
 * Exemplo em App.tsx:
 * 
 * useEffect(() => {
 *   initializeSecurity();
 * }, []);
 */
